import { IHttpService, IHttpRequestTransformer, IHttpResponseTransformer } from 'angular';
import * as dayjs from 'dayjs';

export abstract class DataTransformer {

	public requestTransformers: IHttpRequestTransformer[];
	public responseTransformers: IHttpResponseTransformer[];

	constructor ($http: IHttpService) {
		this.requestTransformers = [this.transformRequest.bind(this)];
		this.responseTransformers = [$http.defaults.transformResponse[0], this.transformResponse.bind(this)];
	}

	public static propertyExists (object, ...propNames: string[]) {
		return propNames.reduce((exists, nextPropName) => {
			return exists || object[nextPropName] != null;
		}, false);
	}

	public static transformToDate (data: any, propName: string): Date {
		return DataTransformer.propertyExists(data, propName) ? dayjs.utc(data[propName]).toDate() : data[propName];
	}

	/**
	 * Transform request
	 */
	private transformRequest (request: any): any {
		return JSON.stringify(this.transformRequestData(request));
	}

	/**
	 * Transform response
	 */
	private transformResponse (response: any): any {
		if (Array.isArray(response)) {
			response.forEach((data) => {
				this.transformResponseData(data);
			});
		} else {
			this.transformResponseData(response);
		}
		return response;
	}

	protected abstract transformRequestData (data: any): any;
	protected abstract transformResponseData (data: any): void;
}
